import { combineReducers } from 'redux';

import configuration from './configuration/reducer';
import configurationChange from './configurationChange/reducer';
import configurationSidebar from './configurationSidebar/reducer';
import configurationViewer from './configurationViewer/reducer';
import loading from './loading/reducer';
import messages from './messages/reducer';
import selectedWall from './selectedWall/reducer';
import settings from './settings/reducer';
import users from './users/reducer';
import wallsMetaData from './wallsMetaData/reducer';

export default combineReducers({
  configuration,
  configurationChange,
  configurationSidebar,
  configurationViewer,
  loading,
  messages,
  selectedWall,
  settings,
  users,
  wallsMetaData,
});
